package net.dipgo.game.board

import net.dipgo.game.PointState
import kotlin.random.Random

/**
 * Zobrist hashing for Go board positions.
 *
 * Pre-computes a table of random Long values for each (x, y, colour) triple.
 * A board's hash is the XOR of the values for every occupied point.
 * This gives O(m²) full-board hashing with excellent collision resistance
 * (64-bit space), and is the standard technique in Go engines.
 */
object ZobristHash {

    private const val MAX_SIZE = 25
    private const val NUM_COLOURS = 9 // PointState A–I

    private val table: Array<Array<LongArray>> = run {
        val rng = Random(0x4449_5047_4F_474FL) // deterministic seed
        Array(MAX_SIZE) { Array(MAX_SIZE) { LongArray(NUM_COLOURS) { rng.nextLong() } } }
    }

    fun hash(boardPosition: BoardPosition): Long {
        var h = 0L
        for (x in 0 until boardPosition.xSize) {
            for (y in 0 until boardPosition.ySize) {
                val ps = boardPosition.getStateOfPoint(x, y)
                if (ps != PointState.EMPTY) {
                    h = h xor table[x][y][ps.ordinal - 1]
                }
            }
        }
        return h
    }
}
